module.exports = __webpack_public_path__ + "img/logo.fe0df23f.png";